import { render, staticRenderFns } from "./CertForm.vue?vue&type=template&id=705b7f41&scoped=true&"
import script from "./CertForm.vue?vue&type=script&lang=js&"
export * from "./CertForm.vue?vue&type=script&lang=js&"
import style0 from "./CertForm.vue?vue&type=style&index=0&id=705b7f41&prod&lang=scss&"
import style1 from "./CertForm.vue?vue&type=style&index=1&id=705b7f41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705b7f41",
  null
  
)

export default component.exports